export const siteInfo = {
  name: 'CPP官网',
  tagline: '官方正版安装包快速获取',
  description: 'CPP官网App下载页面，提供最新版本官方正版安装包，支持Android与iOS系统，安全无毒、极速下载。一键获取CPP官方App，享受完整功能体验，告别第三方风险版本。',
  keywords: 'cpp官网app下载,cpp官方下载,cpp app安装,cpp最新版下载,cpp手机版,cpp安卓下载,cpp苹果下载',
  domain: 'https://lytfzs.cn',
  version: 'v3.8.2',
  versionDate: '2026-07-25',
  androidSize: '48.6 MB',
  iosSize: '52.1 MB',
  androidRequirement: 'Android 8.0 及以上',
  iosRequirement: 'iOS 14.0 及以上',
};

export const heroContent = {
  title: 'CPP 官方正版应用',
  subtitle: '安全 · 极速 · 纯净体验',
  description: '告别第三方风险版本，下载CPP官方正版App，享受完整功能与持续更新支持。覆盖Android与iOS全平台，一键安装，即刻畅享。',
  badgeText: '最新版本 v3.8.2',
  badgeSub: '2026年7月25日发布',
  downloads: '12,800,000+',
  rating: '4.8',
  ratingCount: '286,000+',
};

export const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '官方正版保障',
    description: '所有安装包均来自CPP官方服务器，经过多重安全检测，杜绝恶意代码与捆绑软件，保障您的设备与隐私安全。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速下载体验',
    description: '采用全球CDN加速节点，智能选择最优线路，确保无论身在何处都能享受毫秒级响应与高速下载。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '全平台兼容',
    description: '完美适配Android与iOS双平台，支持最新系统版本，同时向下兼容主流旧版本设备，覆盖面广。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '持续更新维护',
    description: '官方团队7×24小时不间断维护，定期推送功能更新与安全补丁，确保App始终保持最佳状态。',
  },
  {
    id: 5,
    icon: 'ri-user-heart-line',
    title: '纯净用户体验',
    description: '无广告、无弹窗、无强制推送，专注于核心功能体验，让每一次使用都流畅自然、舒心愉悦。',
  },
  {
    id: 6,
    icon: 'ri-customer-service-2-line',
    title: '全天候客服支持',
    description: '专业客服团队在线值守，遇到任何问题均可通过应用内反馈或官网渠道获得及时响应与帮助。',
  },
];

export const versionHighlights = [
  { id: 1, text: '全新UI界面设计，视觉焕新升级' },
  { id: 2, text: '性能优化，启动速度提升40%' },
  { id: 3, text: '新增暗黑模式，呵护夜间用眼' },
  { id: 4, text: '修复若干已知问题，稳定性增强' },
  { id: 5, text: '隐私保护升级，数据加密传输' },
  { id: 6, text: '新增多语言支持，覆盖全球用户' },
];

export const faqs = [
  {
    id: 1,
    question: 'CPP App是否完全免费？',
    answer: '是的，CPP App基础功能完全免费使用。我们提供部分高级增值服务可供选择，但核心体验不受任何限制，您可以放心下载使用。',
  },
  {
    id: 2,
    question: '如何确认下载的是正版安装包？',
    answer: '请务必通过本官方网站（lytfzs.cn）下载安装包。官方安装包带有数字签名验证，安装时系统会自动校验。切勿从第三方站点或不明链接下载，以免安装到被篡改的风险版本。',
  },
  {
    id: 3,
    question: '安装后无法打开怎么办？',
    answer: '首先请确认您的设备满足最低系统要求（Android 8.0+ / iOS 14.0+）。如仍无法打开，请尝试卸载后重新从官网下载最新版本安装。若问题持续存在，请联系在线客服获取技术支持。',
  },
  {
    id: 4,
    question: 'iOS版本如何安装？',
    answer: 'iOS用户可通过本页面点击"iOS下载"按钮跳转至App Store官方页面进行下载安装。所有iOS版本均经过Apple官方审核，确保安全可靠。',
  },
  {
    id: 5,
    question: 'Android安装时提示"未知来源"怎么办？',
    answer: '由于CPP App通过官网直接分发，Android系统可能会提示"允许安装未知来源应用"。请在系统设置中临时开启"允许来自此来源的应用"选项，安装完成后可重新关闭。我们承诺安装包100%安全无恶意代码。',
  },
  {
    id: 6,
    question: '更新版本会丢失数据吗？',
    answer: '正常情况下，覆盖安装更新不会导致数据丢失。但为确保万无一失，我们建议在更新前通过App内的"数据备份"功能进行备份。如遇到数据异常，请联系客服协助恢复。',
  },
  {
    id: 7,
    question: '支持哪些语言？',
    answer: '目前CPP App支持简体中文、繁体中文、英语、日语、韩语、西班牙语、葡萄牙语等12种语言，并会根据用户需求持续增加更多语言支持。',
  },
];

export const reviews = [
  {
    id: 1,
    name: '王小明',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20professional%20portrait%2C%20clean%20background%2C%20friendly%20smile%2C%20modern%20casual%20style%2C%20warm%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    date: '2026-07-28',
    content: '一直在找CPP的官方下载渠道，终于找到了！下载速度飞快，安装过程也很顺利。正版用着就是放心，界面也比之前用的第三方版本清爽多了。',
  },
  {
    id: 2,
    name: '李雨婷',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%2C%20simple%20white%20background%2C%20natural%20smile%2C%20soft%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    date: '2026-07-25',
    content: '之前从某应用市场下载的版本总是闪退，换到官网版本后问题全没了。新版本的暗黑模式太好用了，晚上使用眼睛舒服很多！',
  },
  {
    id: 3,
    name: '张大伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20headshot%20portrait%2C%20clean%20studio%20background%2C%20confident%20expression%2C%20warm%20natural%20light&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    date: '2026-07-20',
    content: '官网下载确实安全，但希望后续能增加一个PC端同步功能，这样手机和电脑之间切换会更方便。整体来说非常满意，推荐给身边朋友了。',
  },
  {
    id: 4,
    name: '陈思涵',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20professional%20portrait%2C%20simple%20light%20background%2C%20warm%20genuine%20smile%2C%20modern%20office%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    date: '2026-07-18',
    content: '客服响应速度超快！安装时遇到了一个小问题，联系在线客服不到2分钟就解决了。这种服务态度真的让人感动，必须给五星好评！',
  },
  {
    id: 5,
    name: '刘浩然',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20headshot%2C%20minimal%20studio%20background%2C%20friendly%20approachable%20look%2C%20soft%20even%20lighting&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 5,
    date: '2026-07-15',
    content: '用了大半年了，一直很稳定。每次更新都能感受到团队的用心，功能越来越完善。强烈建议大家认准官网下载，远离那些捆绑广告的第三方版本。',
  },
];

export const downloadStats = [
  { label: '累计下载', value: '1280万+', icon: 'ri-download-cloud-2-line' },
  { label: '好评率', value: '98.6%', icon: 'ri-thumb-up-line' },
  { label: '覆盖国家', value: '180+', icon: 'ri-global-line' },
  { label: '平均评分', value: '4.8/5.0', icon: 'ri-star-line' },
];

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'tutorial', name: '使用教程', icon: 'ri-book-open-line' },
  { id: 'update', name: '版本更新', icon: 'ri-loop-right-line' },
  { id: 'security', name: '安全指南', icon: 'ri-shield-check-line' },
  { id: 'tips', name: '技巧分享', icon: 'ri-lightbulb-line' },
  { id: 'news', name: '官方公告', icon: 'ri-megaphone-line' },
];

export const articles = [
  {
    id: 1,
    category: 'tutorial',
    title: 'CPP App 新手指南：从下载到上手只需5分钟',
    excerpt: '刚接触CPP App？别担心！这篇详细的新手指南将带你一步步完成下载、安装、注册到基础功能使用的全过程，让你快速成为使用高手。',
    content: `## 第一步：下载安装

首先，请访问CPP官方网站（lytfzs.cn），根据您的设备选择对应的下载按钮。

**Android用户**：点击"Android下载"按钮，等待APK安装包下载完成。下载完成后，点击安装包按照系统提示完成安装。如果系统提示"允许安装未知来源应用"，请临时开启该权限。

**iOS用户**：点击"iOS下载"按钮，系统将自动跳转至App Store官方页面，点击"获取"即可安装。

## 第二步：注册账号

安装完成后，打开CPP App，您将看到欢迎页面。点击"注册新账号"，输入手机号码或邮箱地址，获取验证码后设置密码即可完成注册。

## 第三步：基础功能探索

注册成功后，系统将引导您完成初始设置。您可以根据个人偏好选择主题风格、通知偏好等。主界面功能分区清晰，底部导航栏包含首页、发现、消息、我的四个核心模块。

## 第四步：个性化设置

进入"我的"页面，您可以：
- 编辑个人资料与头像
- 设置隐私与安全选项
- 管理通知偏好
- 查看存储与缓存使用情况

现在您已经准备就绪，开始享受CPP带来的完整功能体验吧！`,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20onboarding%20screenshot%20display%20on%20phone%20with%20clean%20minimal%20interface%2C%20warm%20ambient%20lighting%2C%20flat%20lay%20composition%2C%20soft%20neutral%20background&width=800&height=450&seq=article-01&orientation=landscape',
    author: 'CPP官方团队',
    date: '2026-08-01',
    readTime: '8分钟',
    tags: ['新手指南', '下载教程', '入门'],
    related: [2, 4, 6],
  },
  {
    id: 2,
    category: 'tutorial',
    title: '10个CPP App隐藏功能，99%的用户都不知道',
    excerpt: 'CPP App除了基础功能外，还藏着许多实用又强大的隐藏功能。本文为你揭秘10个鲜为人知的操作技巧，让你的使用效率翻倍提升！',
    content: `CPP App经过多个版本的迭代，积累了众多强大的隐藏功能。以下是10个最实用的隐藏技巧：

## 1. 手势操作快捷键
在主界面双指下滑可以快速切换至夜间模式，双指上滑则恢复日间模式。左右滑动导航栏可以快速切换标签页。

## 2. 智能搜索语法
在搜索框输入"@用户名"可直接搜索用户，"#话题"可搜索相关话题内容，"!功能名"可直接跳转到对应功能页面。

## 3. 离线模式
在"设置-通用"中开启离线模式后，App会自动缓存常用内容，即使在无网络环境下也能浏览已缓存的信息。

## 4. 批量操作
长按任意列表项进入多选模式，可以批量删除、标记、分享或导出相关内容，大幅提升操作效率。

## 5. 自定义快捷菜单
在"设置-快捷方式"中，您可以自定义底部导航栏的快捷功能按钮，将最常用的功能放在触手可及的位置。

## 6. 隐私空间
在"我的-隐私空间"中设置独立密码，可将私密内容存储在加密空间中，即使手机借给他人使用也不会泄露隐私。

## 7. 智能提醒
在任务或日程功能中，支持基于位置的智能提醒——当您到达或离开指定地点时自动触发提醒通知。

## 8. 数据导出
在"设置-数据管理"中，支持将个人数据以多种格式（JSON、CSV、PDF）导出，方便备份或迁移。

## 9. 语音输入
在任意文本输入界面长按麦克风图标，即可启动语音输入功能，支持普通话、英语等多种语言的高精度识别。

## 10. 小组件
iOS和Android均支持桌面小组件功能，无需打开App即可查看关键信息或执行快捷操作。

掌握这些技巧后，相信您的CPP使用体验会有一个质的飞跃！`,
    cover: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20app%20interface%20with%20hidden%20features%20discovery%2C%20dark%20mode%20theme%2C%20clean%20modern%20UI%20design%2C%20soft%20glowing%20accent%20elements&width=800&height=450&seq=article-02&orientation=landscape',
    author: 'CPP产品团队',
    date: '2026-07-28',
    readTime: '12分钟',
    tags: ['隐藏功能', '使用技巧', '效率提升'],
    related: [1, 3, 5],
  },
  {
    id: 3,
    category: 'update',
    title: 'CPP v3.8.2 版本更新日志：全新UI与性能飞跃',
    excerpt: 'CPP最新版本v3.8.2正式发布！本次更新带来了全新的界面设计语言、大幅性能优化以及多项用户期待已久的新功能。',
    content: `我们很高兴地宣布，CPP v3.8.2 版本已正式发布！本次更新是今年最重要的一次版本迭代，以下是详细更新内容：

## 全新UI设计
- 采用全新的设计语言，界面更加简洁清爽
- 重新设计图标体系，视觉统一性大幅提升
- 优化信息层级，关键功能更加突出
- 新增多种主题配色方案供选择

## 性能飞跃
- 应用冷启动速度提升40%
- 页面切换流畅度提升60%
- 内存占用降低25%
- 安装包体积优化缩小18%

## 暗黑模式
- 全新暗黑模式，支持定时自动切换
- 针对OLED屏幕深度优化，更省电
- 自适应系统深色模式设置

## 安全增强
- 数据传输全面升级为端到端加密
- 新增 biometric 生物识别登录支持
- 隐私权限管理更加精细化
- 安全漏洞扫描与修复

## Bug修复
- 修复部分机型上的闪退问题
- 修复通知延迟送达的偶发问题
- 修复搜索历史无法清除的问题
- 修复横竖屏切换时的布局异常`,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20app%20version%20update%20announcement%20design%2C%20clean%20gradient%20abstract%20background%20with%20version%20number%203.8.2%2C%20soft%20warm%20tones%2C%20tech%20vibe&width=800&height=450&seq=article-03&orientation=landscape',
    author: 'CPP开发团队',
    date: '2026-07-25',
    readTime: '6分钟',
    tags: ['版本更新', 'v3.8.2', '新功能'],
    related: [4, 5, 7],
  },
  {
    id: 4,
    category: 'update',
    title: 'CPP v3.7.0 回顾：那些改变用户体验的重大更新',
    excerpt: '回顾CPP v3.7.0版本带来的核心改进，看看这些功能如何深刻影响了千万用户的日常使用体验。',
    content: `CPP v3.7.0 版本是CPP发展历程中的一个重要里程碑。让我们回顾一下这个版本带来的重大变化。

## 智能推荐引擎
v3.7.0引入了基于AI的智能推荐引擎，能够根据用户的使用习惯和偏好，精准推荐相关内容。上线后用户活跃度提升了35%。

## 社交互动升级
全新的社交模块让用户之间的互动更加丰富。新增的群组功能、实时协作工具以及增强的分享机制，让CPP从一个工具App真正转变为社区平台。

## 无障碍优化
我们深知科技应该服务于每一个人。v3.7.0对无障碍功能进行了全面升级，支持屏幕阅读器、高对比度模式、字体大小无极调节等功能。

## 国际化扩展
v3.7.0新增了对西班牙语、葡萄牙语和阿拉伯语的支持，使CPP的全球用户覆盖率进一步提升。`,
    cover: 'https://readdy.ai/api/search-image?query=Timeline%20visualization%20of%20app%20version%20history%20with%20glowing%20nodes%20connected%2C%20modern%20minimal%20tech%20design%2C%20warm%20amber%20accents%20on%20dark%20background&width=800&height=450&seq=article-04&orientation=landscape',
    author: 'CPP产品团队',
    date: '2026-07-10',
    readTime: '8分钟',
    tags: ['版本回顾', 'v3.7.0', '产品历程'],
    related: [3, 6, 8],
  },
  {
    id: 5,
    category: 'security',
    title: 'CPP安全白皮书：我们如何保护您的数据安全',
    excerpt: '数据安全是CPP的立身之本。本文详细阐述CPP在数据加密、隐私保护和合规方面的技术方案与实践承诺。',
    content: `在数字化时代，数据安全与隐私保护是每个用户最关心的问题。CPP始终将用户数据安全放在首位。

## 端到端加密
所有用户数据在传输过程中均采用AES-256加密标准，确保数据在传输链路上的任何一个节点都不会被窃取或篡改。

## 数据最小化原则
我们仅收集提供服务所必需的最少数据。每一个数据收集点都经过严格的必要性评估，绝不过度采集用户信息。

## 隐私合规
CPP严格遵守GDPR（欧盟通用数据保护条例）和中国《个人信息保护法》，用户拥有对其数据的完全控制权，包括查看、导出和删除。

## 安全认证
CPP已通过ISO 27001信息安全管理体系认证和SOC 2 Type II审计，安全能力获得国际权威认可。`,
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20clean%20minimal%20design%2C%20warm%20light%20background%20with%20subtle%20data%20stream%20visuals&width=800&height=450&seq=article-05&orientation=landscape',
    author: 'CPP安全团队',
    date: '2026-07-05',
    readTime: '10分钟',
    tags: ['数据安全', '隐私保护', '加密技术'],
    related: [1, 6, 9],
  },
  {
    id: 6,
    category: 'tips',
    title: '提升效率的5个CPP快捷操作，每天省下1小时',
    excerpt: '学会这些CPP快捷操作技巧，让你在日常使用中事半功倍。实测每天可节省至少1小时的操作时间！',
    content: `效率是现代人的核心追求。以下是5个经过实测验证的CPP快捷操作技巧：

## 1. 键盘快捷键
连接蓝牙键盘后，CPP支持丰富的键盘快捷键。最常用的包括：Ctrl+N 新建、Ctrl+S 保存、Ctrl+F 搜索、Ctrl+D 收藏。

## 2. Siri快捷指令（iOS）
iOS用户可以在"快捷指令"App中创建CPP相关操作，通过Siri语音直接执行。例如"嘿Siri，打开CPP扫一扫"。

## 3. 定时任务自动化
在"工具-自动化"中，可以设置定时执行的任务，如每日定时备份数据、定时清理缓存等。

## 4. 智能分类规则
在"设置-分类规则"中创建自动分类条件，新内容将自动归入对应分类，告别手动整理。

## 5. 模板功能
对于经常重复的操作，可以创建模板一键套用。支持文本模板、表格模板和操作流程模板三种类型。`,
    cover: 'https://readdy.ai/api/search-image?query=Productivity%20concept%20with%20smartphone%20showing%20quick%20actions%20interface%2C%20clean%20desk%20setup%2C%20warm%20natural%20light%2C%20minimal%20workspace%20aesthetic&width=800&height=450&seq=article-06&orientation=landscape',
    author: 'CPP效率研究组',
    date: '2026-06-28',
    readTime: '7分钟',
    tags: ['效率提升', '快捷操作', '实用技巧'],
    related: [2, 7, 8],
  },
  {
    id: 7,
    category: 'news',
    title: 'CPP用户突破1000万！感恩回馈活动盛大开启',
    excerpt: '热烈庆祝CPP全球注册用户突破1000万里程碑！为感谢广大用户的支持与信任，我们准备了丰厚的感恩回馈活动。',
    content: `## 里程碑时刻

今天，我们怀着无比激动的心情宣布：CPP全球注册用户正式突破1000万！

自上线以来，CPP始终坚持以用户为中心的产品理念，不断迭代优化。从最初的几百名种子用户，到如今千万级别的用户规模，每一步成长都离不开每一位用户的支持与信任。

## 感恩回馈活动

为庆祝这一重要时刻，我们推出了系列感恩活动：

### 活动一：邀请有礼
即日起至8月31日，每成功邀请一位新用户注册，双方均可获得30天高级会员体验。

### 活动二：创作大赛
分享你与CPP的故事，优秀作品将获得官方推荐，还有机会赢取最新旗舰手机等大奖。

### 活动三：反馈有奖
提交产品改进建议，被采纳的前100名用户将获得限量版CPP周边礼盒。

感谢一千万分之一的你，CPP因你而精彩！`,
    cover: 'https://readdy.ai/api/search-image?query=Celebration%20concept%20with%20abstract%20confetti%20and%2010%20million%20number%20design%2C%20warm%20festive%20atmosphere%2C%20clean%20modern%20flat%20design%20style&width=800&height=450&seq=article-07&orientation=landscape',
    author: 'CPP运营团队',
    date: '2026-06-20',
    readTime: '5分钟',
    tags: ['官方公告', '用户里程碑', '活动'],
    related: [3, 8, 9],
  },
  {
    id: 8,
    category: 'tips',
    title: 'CPP App与其他同类工具对比：为什么选择CPP',
    excerpt: '市面上的工具App琳琅满目，CPP凭什么脱颖而出？我们从功能、安全、体验三个维度进行全面对比分析。',
    content: `选择一款合适的工具App并不容易。本文从客观角度对比CPP与市面上其他主流工具App的差异。

## 安全性对比
CPP是少数通过ISO 27001和SOC 2双重认证的App，在数据加密和隐私保护方面处于行业领先水平。相比同类产品，CPP不依赖第三方广告SDK，从根本上杜绝了隐私泄露风险。

## 功能完整度
CPP提供从基础功能到高级专业功能的完整体验，且核心功能完全免费。许多竞品将基础功能拆分为付费模块，用户体验割裂。

## 性能表现
在独立第三方测试中，CPP在启动速度、内存占用和功耗控制方面均优于行业平均水平。v3.8.2版本的性能优化更是将差距进一步拉大。

## 用户体验
CPP坚持"少即是多"的设计理念，拒绝功能堆砌。用户调研显示，新用户上手CPP的平均时间仅为同类产品的60%。

## 持续更新
CPP保持每月至少一次版本更新的节奏，而许多竞品数月才更新一次。活跃的更新频率确保了安全补丁及时发布和新功能快速迭代。`,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20comparison%20chart%20visualization%20with%20minimal%20design%2C%20soft%20color%20palette%2C%20abstract%20geometric%20shapes%20representing%20different%20products%2C%20professional%20layout&width=800&height=450&seq=article-08&orientation=landscape',
    author: 'CPP产品团队',
    date: '2026-06-15',
    readTime: '9分钟',
    tags: ['产品对比', '选择指南', '功能分析'],
    related: [1, 5, 9],
  },
  {
    id: 9,
    category: 'security',
    title: '警惕假冒CPP应用！5招教你识别正版与山寨',
    excerpt: '近期市面上出现大量假冒CPP的山寨应用，它们不仅功能残缺，更可能窃取您的个人信息。学会这5招，远离山寨风险。',
    content: `## 山寨应用的危害

近期，我们接到大量用户反馈，称在第三方应用市场下载到了假冒的CPP应用。这些山寨应用不仅功能残缺、体验极差，更严重的是，它们可能：

- 窃取个人敏感信息
- 植入恶意广告和弹窗
- 暗中消耗流量和电量
- 获取通讯录和短信权限
- 诱导付费订阅

## 5招识别正版CPP

### 第一招：认准官方下载渠道
唯一的官方下载渠道是 lytfzs.cn 官网和 Apple App Store。任何其他网站提供的下载链接都有风险。

### 第二招：检查数字签名
Android用户安装时，查看安装包的数字签名。正版CPP的签名为"CPP Official Team"。如签名不一致，请立即停止安装。

### 第三招：核对应用信息
正版CPP的开发者为"CPP Technology Co., Ltd."，应用大小约为48-52MB。山寨应用通常体积异常（过大或过小）。

### 第四招：查看用户评价
在App Store中，正版CPP拥有超过28万条评价，平均评分4.8分。山寨应用的评论数量少且评分异常。

### 第五招：观察启动画面
正版CPP启动时会显示官方Logo和"安全检测中"的加载动画。山寨应用通常没有启动画面或显示粗糙的仿制Logo。

如果您发现了疑似山寨的CPP应用，请立即通过官网客服渠道举报，我们将联合相关部门进行打击处理。`,
    cover: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20fake%20vs%20real%20app%20comparison%20with%20warning%20signs%2C%20security%20awareness%20concept%2C%20clean%20modern%20design%2C%20warm%20lighting&width=800&height=450&seq=article-09&orientation=landscape',
    author: 'CPP安全团队',
    date: '2026-06-08',
    readTime: '8分钟',
    tags: ['安全警示', '正版识别', '防骗指南'],
    related: [5, 1, 3],
  },
];

export const aboutContent = {
  intro: {
    title: '关于CPP',
    content: 'CPP是由CPP Technology Co., Ltd.开发的移动应用产品，致力于为全球用户提供安全、高效、纯净的移动应用体验。自成立以来，我们始终秉持"用户至上、安全第一"的产品理念，不断探索技术创新与用户体验的完美平衡。\n\n目前，CPP已覆盖全球180多个国家和地区，累计服务超过1280万用户，凭借出色的产品体验和安全保障赢得了广泛信赖。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20interior%20with%20natural%20light%2C%20clean%20minimal%20design%2C%20team%20collaboration%20atmosphere%2C%20warm%20wooden%20accents%2C%20professional%20yet%20inviting%20environment&width=700&height=500&seq=about-intro&orientation=landscape',
  },
  mission: '我们的使命是通过技术创新，为每一位用户打造安全可靠、体验卓越的移动应用产品。我们相信，好的产品应该让用户用得放心、用得舒心。',
  values: [
    { id: 1, title: '安全至上', description: '将数据安全与隐私保护视为产品生命线，持续投入安全技术研发。' },
    { id: 2, title: '用户为本', description: '每一个功能设计的出发点都是用户需求，持续倾听并响应用户反馈。' },
    { id: 3, title: '追求极致', description: '不满足于"够用"，持续打磨每一个细节，追求极致的产品体验。' },
    { id: 4, title: '开放透明', description: '保持与用户社区的开放沟通，产品路线图和发展方向公开透明。' },
  ],
  milestones: [
    { year: '2020', event: 'CPP项目正式立项，核心团队组建完成' },
    { year: '2021', event: 'CPP v1.0 正式上线，首月用户突破10万' },
    { year: '2022', event: '注册用户突破100万，完成A轮融资' },
    { year: '2023', event: '通过ISO 27001认证，全球化战略启动' },
    { year: '2024', event: '用户突破500万，新增8种语言支持' },
    { year: '2025', event: '通过SOC 2 Type II审计，完成B轮融资' },
    { year: '2026', event: '全球用户突破1280万，推出v3.8.2重大更新' },
  ],
  contact: {
    email: 'support@lytfzs.cn',
    phone: '400-888-CPPP（2777）',
    address: '广东省深圳市南山区科技园南路88号CPP大厦',
    wechat: 'CPPOfficial',
    weibo: '@CPP官方',
    hours: '周一至周日 9:00 - 21:00（北京时间）',
  },
};